import { Component } from '@angular/core';

@Component({
  selector: 'app-demo-badge',
  templateUrl: './demo-badge.component.html',
  styleUrl: './demo-badge.component.scss'
})
export class DemoBadgeComponent {

}
